
import {
 
  FETCH_TIMELINE_REPORT_REQUEST,
  FETCH_TIMELINE_REPORT_SUCCESS,
  FETCH_TIMELINE_REPORT_FAILURE,
} from './actionTypes';

const initialState = {

  timelineReport: {
    data: [],
    loading: false,
    error: null,
  },
};

const timelineReducer = (state = initialState, action) => {
  switch (action.type) {

    
    case FETCH_TIMELINE_REPORT_REQUEST:
      return {
        ...state,
        timelineReport: {
          ...state.timelineReport,
          loading: true,
          error: null,
        },
      };
      
    case FETCH_TIMELINE_REPORT_SUCCESS:
      return {
        ...state,
        timelineReport: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
      
    case FETCH_TIMELINE_REPORT_FAILURE:
      return {
        ...state,
        timelineReport: {
          ...state.timelineReport,
          loading: false,
          error: action.payload,
        },
      };
      
    default:
      return state;
  }
};

export default timelineReducer;